import { createModule } from '../../createModule';
import { appendFiles } from '../../shared';
export const createUploadTrackAPI = createModule(({ http }) => {
    return {
        getInstruments: async (params) => {
            const res = await http.get('/v2/upload-track/marketdata/instruments', { params });
            return res;
        },
        updateInstrument: async (body) => {
            const res = await http.patch('/v2/upload-track/marketdata/instruments', {
                body: body,
            });
            return res;
        },
        getMarketdataSpot: async (params) => {
            const res = await http.get('/v2/upload-track/marketdata/spot', { params });
            return res;
        },
        uploadFiles: async (body) => {
            const formData = new FormData();
            appendFiles(formData, 'files', body.files);
            formData.append('update_type', body.update_type);
            const res = await http.post('/v2/upload-track/price-track/files', { body: formData });
            return res;
        },
    };
});
